var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopRightStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 147,
    viewBox: "0 0 118 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.355 141.682C34.355 138.973 36.551 136.777 39.26 136.777C41.969 136.777 44.165 138.973 44.165 141.682C44.165 144.391 41.969 146.587 39.26 146.587C36.551 146.587 34.355 144.391 34.355 141.682Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.079 103.691C111.079 102.013 112.439 100.653 114.117 100.653C115.795 100.653 117.155 102.013 117.155 103.691C117.155 105.369 115.795 106.729 114.117 106.729C112.44 106.729 111.079 105.369 111.079 103.691Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 103.691C-6.10352e-05 102.013 1.35993 100.653 3.03793 100.653C4.71593 100.653 6.07593 102.013 6.07593 103.691C6.07593 105.369 4.71593 106.729 3.03793 106.729C1.36093 106.729 -6.10352e-05 105.369 -6.10352e-05 103.691Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8351 -1.52588e-05C28.1572 -1.52588e-05 26.7971 1.36015 26.7971 3.03799C26.7971 4.71584 28.1572 6.07599 29.8351 6.07599C31.5129 6.07599 32.873 4.71584 32.873 3.03799C32.873 1.36015 31.5129 -1.52588e-05 29.8351 -1.52588e-05Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.235 26.347C91.334 20.742 86.939 16.348 81.335 15.447C86.94 14.546 91.334 10.151 92.235 4.54698C93.136 10.152 97.531 14.546 103.135 15.447C97.53 16.348 93.136 20.743 92.235 26.347Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightStars);
export default __webpack_public_path__ + "static/media/top-right-stars.6752c936b6da030a5ae3b1a8d56847cb.svg";
export { ForwardRef as ReactComponent };